(() => {
  const skipButton = document.querySelector('[data-live-chat-skip]');
  const announcer = document.getElementById('live-chat-announcer');

  if (!skipButton) {
    return;
  }

  const iframeTitle = skipButton.dataset.liveChatIframeTitle || 'Live chat';
  const openedMessage =
    skipButton.dataset.liveChatOpenedMessage || `${iframeTitle} opened.`;
  let widgetOpenedHandlerBound = false;
  let focusAttemptInterval = null;
  let focusRequested = false;

  const FOCUS_ATTEMPT_MS = 100;
  const FOCUS_ATTEMPT_MAX = 50;
  const EXPANDED_IFRAME_MIN_HEIGHT = 100;
  const EXPANDED_IFRAME_MIN_WIDTH = 200;

  function getFcWidgetIframe() {
    return document.getElementById('fc_widget');
  }

  function isVisible(element) {
    if (!element) {
      return false;
    }

    const style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) {
      return false;
    }

    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function isChatOpen() {
    const iframe = getFcWidgetIframe();
    if (!iframe || !isVisible(iframe)) {
      return false;
    }

    if (focusRequested) {
      return true;
    }

    const openLauncher = document.querySelector('.hotline-launcher.h-open');
    if (openLauncher && isVisible(openLauncher)) {
      return true;
    }

    const rect = iframe.getBoundingClientRect();
    return rect.height > EXPANDED_IFRAME_MIN_HEIGHT || rect.width > EXPANDED_IFRAME_MIN_WIDTH;
  }

  function requestChatFocus() {
    focusRequested = true;
    tryFocusFcWidget();
    scheduleFocusAttempts();
  }

  function announceChatOpened() {
    if (!announcer) {
      return;
    }

    announcer.textContent = '';
    window.requestAnimationFrame(() => {
      announcer.textContent = openedMessage;
    });
  }

  function tryFocusFcWidget() {
    const iframe = getFcWidgetIframe();

    if (!focusRequested || !iframe || !isChatOpen() || !isVisible(iframe)) {
      return false;
    }

    skipButton.blur();

    iframe.setAttribute('title', iframeTitle);
    iframe.setAttribute('tabindex', '-1');

    const launcher =
      iframe.closest('.hotline-launcher.h-open') || document.querySelector('.hotline-launcher.h-open');
    if (launcher) {
      launcher.setAttribute('tabindex', '-1');
      launcher.focus({ preventScroll: false });
    }

    iframe.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    iframe.focus({ preventScroll: false });

    if (document.activeElement !== iframe) {
      iframe.tabIndex = 0;
      iframe.focus({ preventScroll: false });
      iframe.tabIndex = -1;
    }

    try {
      iframe.contentWindow?.focus();
    } catch (_error) {
      /* cross-origin */
    }

    if (document.activeElement === iframe) {
      announceChatOpened();
      return true;
    }

    return false;
  }

  function scheduleFocusAttempts() {
    if (focusAttemptInterval) {
      window.clearInterval(focusAttemptInterval);
    }

    let attempts = 0;

    focusAttemptInterval = window.setInterval(() => {
      attempts += 1;

      if (tryFocusFcWidget() || attempts >= FOCUS_ATTEMPT_MAX) {
        window.clearInterval(focusAttemptInterval);
        focusAttemptInterval = null;

        if (attempts >= FOCUS_ATTEMPT_MAX && isChatOpen()) {
          announceChatOpened();
        }
      }
    }, FOCUS_ATTEMPT_MS);
  }

  function bindWidgetOpenedHandler(widget) {
    if (!widget || widgetOpenedHandlerBound || typeof widget.on !== 'function') {
      return;
    }

    widgetOpenedHandlerBound = true;

    widget.on('widget:opened', () => {
      window.requestAnimationFrame(() => {
        requestChatFocus();
      });
    });
  }

  function watchForFcWidgetAvailability() {
    const tryBind = () => bindWidgetOpenedHandler(window.fcWidget);

    if (window.fcWidget) {
      tryBind();
      return;
    }

    const observer = new MutationObserver(() => {
      if (!window.fcWidget) {
        return;
      }

      tryBind();
      observer.disconnect();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function openChatWidget() {
    const widget = window.fcWidget;

    if (widget && typeof widget.open === 'function') {
      bindWidgetOpenedHandler(widget);
      widget.open();
      return true;
    }

    const launcher =
      document.querySelector('.fc-widget-normal') ||
      document.querySelector('.hotline-launcher:not(.h-open)') ||
      document.querySelector('#fc_frame');

    if (launcher) {
      launcher.click();
      return true;
    }

    return false;
  }

  function openChatWidgetWhenReady() {
    const loadLiveChat = window.haleLoadLiveChat;
    const loadPromise = typeof loadLiveChat === 'function' ? loadLiveChat() : Promise.resolve();

    loadPromise.catch(() => {}).finally(() => {
      let attempts = 0;
      const openAttemptInterval = window.setInterval(() => {
        attempts += 1;

        if (openChatWidget()) {
          window.clearInterval(openAttemptInterval);
          requestChatFocus();
          return;
        }

        if (attempts >= FOCUS_ATTEMPT_MAX) {
          window.clearInterval(openAttemptInterval);
        }
      }, FOCUS_ATTEMPT_MS);
    });
  }

  bindWidgetOpenedHandler(window.fcWidget);
  watchForFcWidgetAvailability();

  skipButton.addEventListener('click', (event) => {
    event.preventDefault();
    openChatWidgetWhenReady();
  });
})();
